import { getMobileWidgetPropsComponent } from './MobileWidget/MobileWidgetProps';
import { WidgetType } from './types';
import { getWebWidgetPropsComponent } from './WebWidget/WebWidgetProps';
import { WidgetDefinition } from './WidgetBuilder/types';
export interface WidgetPropsComponentProps {
  config: WidgetDefinition;
  updateConfig: ( key: keyof WidgetDefinition, value: any ) => void;
}

export const getWidgetPropsComponent = ( widgetType: WidgetType, device: 'web' | 'mobile' ): React.ComponentType<WidgetPropsComponentProps> => {
  const deviceGetWidgetPropsComponent = {
    web: getWebWidgetPropsComponent,
    mobile: getMobileWidgetPropsComponent
  };
  return deviceGetWidgetPropsComponent[device]( widgetType );
};